import { applyMiddleware, compose, createStore, Store } from 'redux'
import { persistStore } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import createRootReducer from '../redux/index.web'
import rootSaga from '../sagas'
import { IAppState } from './state.interface.web'
import { STARTUP } from '../redux/index.web'

export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()

const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose

export const store: Store<IAppState> = createStore(
  createRootReducer(history),
  composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
)

export const persistor = persistStore(store, {}, () => {
  store.dispatch(STARTUP.trigger())
})

sagaMiddleware.run(rootSaga)

export default store
